<template>
  <div class="app-files-uploader">
    <div class="app-files-uploader__description">
      {{ $t('APP.RELEASES.ADD_APK_OR_AAB') }}
    </div>

    <DroppableResumableUploader
      v-loading="loading"
      v-bind="$attrs"
      multiple
      :accept="validFileExtensions"
      :files-filter-function="normalizeFilesForUpload"
      :upload-url="getFileUploadUrl"
      @upload-done="updateDraftApp"
    />

    <ElAlert
      v-for="(value, name) in fileErrors"
      :key="name"
      :title="$t('APP.RELEASES.PACKAGE_ERROR', { name })"
      :closable="false"
      class="app-files-uploader__error"
      type="error"
      show-icon
    >
      {{ value }}
    </ElAlert>
  </div>
</template>

<script>
import DroppableResumableUploader from '@@/common/file-uploaders/DroppableResumableUploader';
import { apiPath } from '@/api/constants';
import { UPDATE_DRAFT_APP } from '@/store/types';
import { mapActions } from 'vuex';

export default {
  name: 'AppFilesUploader',

  components: {
    DroppableResumableUploader,
  },

  props: {
    canUploadBundle: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      loading: false,
      fileErrors: {},
    };
  },

  computed: {
    validFileExtensions() {
      return this.canUploadBundle ? '.aab,.apk' : '.apk';
    },
  },

  methods: {
    ...mapActions({ updateDraftAppInStore: UPDATE_DRAFT_APP }),

    normalizeFilesForUpload(files = []) {
      const isAAB = ({ name }) => name.endsWith('.aab');
      const isAPK = ({ name }) => name.endsWith('.apk');

      const aabFile = files.find(isAAB);
      if (aabFile) return [aabFile];
      return files.filter(isAPK);
    },

    updateDraftApp(responses) {
      const { draftApp } = responses[responses.length - 1];
      this.updateDraftAppInStore(draftApp);
    },

    getFileUploadUrl({ name }) {
      const fileExtension = name
        .split('.')
        .pop()
        .toLowerCase();

      const appId = this.$route.params.appId;
      const extensionUploadEndpoints = {
        apk: `${apiPath}/draft-apps/${appId}/upload/apk/`,
        aab: `${apiPath}/draft-apps/${appId}/upload/aab/`,
      };

      return extensionUploadEndpoints[fileExtension];
    },
  },
};
</script>

<style lang="scss">
.app-files-uploader {
  &__error {
    margin-bottom: $global-margin;
  }

  &__description {
    margin-bottom: $global-margin;
  }
}
</style>
